import React, { useState, useEffect } from 'react';
import { Fade } from 'react-bootstrap';
import ReactTimeAgo from 'react-time-ago';

const ActivityText = ({ postId }) => {
    const [activity, setActivity] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const fetchActivity = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/findLastActivity/${postId}`);
                const data = await response.json();

                if (data.length > 0 && data[0].action_timestamp) {
                    const newActivity = {
                        username: data[0].username,
                        action_type: data[0].action_type,
                        action_timestamp: data[0].action_timestamp
                    };

                    // Check if the new activity is different from the current one
                    if (!activity || activity.action_timestamp !== newActivity.action_timestamp || activity.action_type !== newActivity.action_type) {
                        // Trigger fade out
                        setFade(false);
                        setTimeout(() => {
                            // Update activity data and trigger fade in
                            setActivity(newActivity);
                            setFade(true);
                        }, 300); // Adjust the timing to control fade out duration
                    }
                } else {
                    setActivity(null);
                }
            } catch (error) {
                console.error("Error fetching activity:", error);
                setActivity(null);
            } finally {
                setLoading(false);
            }
        };

        fetchActivity();
        const intervalId = setInterval(fetchActivity, 5000); // Poll every 5 seconds
        return () => clearInterval(intervalId); // Clean up on unmount
    }, [postId, activity]);

    if (loading) {
        return <div>Loading activity...</div>;
    }

    if (!activity) return null;

    return (
        <Fade in={fade}>
            <div className="activity-text">
                <p>
                    <strong>{activity.username}</strong>{activity.action_type === "like" ? " a apreciat postarea" : " a adăugat un comentariu"} 
                    {' '}<ReactTimeAgo date={new Date(activity.action_timestamp)} locale="en-US" />
                </p>
            </div>
        </Fade>
    );
};

export default ActivityText;
